/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Hero_Title_ShareInputs */

const en_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share.`)
};

const es_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comparte.`)
};

const fr_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partagez.`)
};

const de_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen.`)
};

const ja_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`共有。`)
};

const zh_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分享。`)
};

const ar_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شارك.`)
};

const id_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagikan.`)
};

const it_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condividi.`)
};

const ru_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Делись.`)
};

const pt_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compartilhe.`)
};

const ko_home_hero_title_share = /** @type {(inputs: Home_Hero_Title_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`공유.`)
};

/**
* | output |
* | --- |
* | "Share." |
*
* @param {Home_Hero_Title_ShareInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_hero_title_share = /** @type {((inputs?: Home_Hero_Title_ShareInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Hero_Title_ShareInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_hero_title_share(inputs)
	if (locale === "es") return es_home_hero_title_share(inputs)
	if (locale === "fr") return fr_home_hero_title_share(inputs)
	if (locale === "de") return de_home_hero_title_share(inputs)
	if (locale === "ja") return ja_home_hero_title_share(inputs)
	if (locale === "zh") return zh_home_hero_title_share(inputs)
	if (locale === "ar") return ar_home_hero_title_share(inputs)
	if (locale === "id") return id_home_hero_title_share(inputs)
	if (locale === "it") return it_home_hero_title_share(inputs)
	if (locale === "ru") return ru_home_hero_title_share(inputs)
	if (locale === "pt") return pt_home_hero_title_share(inputs)
	return ko_home_hero_title_share(inputs)
});